module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: "<div class=\"activity\" style=\"border-left: 4px solid <%= specialColorBorder %>; background: <%= specialColor %>;\">\n    <span style=\"color:<%= specialTextColor %>\"><%= booking.get('time') %></span>\n    <span style=\"color:<%= specialTextColor %>\"><%= booking.get('activity').get('name') %></span>\n    <span style=\"color:<%= specialTextColor %>\"><%= booking.get('studio').get('name') %> <% if (booking.get('coach')) { %>- <%= booking.get('coach').get('name') %><% } %></span>\n</div>\n<% if (booking.get('suppressionDate')) { %>\n    <span class=\"canceled\" style=\"margin-bottom: 11px\">annulé</span>\n<% } %>\n<div class=\"booking_tooltip\" style=\"display: none\"></div>\n",
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="activity" style="border-left: 4px solid ', escape((__stack.lineno = 1, specialColorBorder)), "; background: ", escape((__stack.lineno = 1, specialColor)), ';">\n    <span style="color:', escape((__stack.lineno = 2, specialTextColor)), '">', escape((__stack.lineno = 2, booking.get("time"))), '</span>\n    <span style="color:', escape((__stack.lineno = 3, specialTextColor)), '">', escape((__stack.lineno = 3, booking.get("activity").get("name"))), '</span>\n    <span style="color:', escape((__stack.lineno = 4, specialTextColor)), '">', escape((__stack.lineno = 4, booking.get("studio").get("name"))), " ");
                __stack.lineno = 4;
                if (booking.get("coach")) {
                    buf.push("- ", escape((__stack.lineno = 4, booking.get("coach").get("name"))), "");
                    __stack.lineno = 4;
                }
                buf.push("</span>\n</div>\n");
                __stack.lineno = 6;
                if (booking.get("suppressionDate")) {
                    buf.push('\n    <span class="canceled" style="margin-bottom: 11px">annulé</span>\n');
                    __stack.lineno = 8;
                }
                buf.push('\n<div class="booking_tooltip" style="display: none"></div>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1750691733-2.1.11/node_modules/ejs-compiled-loader!./src/templates/main_booking_special.ejs
// module id = 137
// module chunks = 0